import axios from "axios";
import { PROJECT_FOCUS_FIELDS } from "constants/settings.constants";

import { USER_COLUMN_RS_ENDPOINT } from "api/data";

import { EntityKind } from "models/entityKind";

import { IGroupByListColumn } from "../../../models";
import { fetchGeomBins } from "./fetchGeomBins";

const GeomBinPrefix = "GeomBin";
const ProjectDefinedColumnPropertyPrefix = "Project_Focus_Fields";

export const fetchProjectDefinedColumns = async (
  entityKind: EntityKind = EntityKind.Well,
  selectedProjectId?: string
): Promise<IGroupByListColumn[]> => {
  try {
    let projectList = null;
    if (!selectedProjectId) {
      return [];
    }

    const projectDefinedColumnsResponse = await axios.get(
      `${USER_COLUMN_RS_ENDPOINT}/project/${selectedProjectId}?entityKind=${entityKind.toString()}`
    );

    let columns: IGroupByListColumn[] = [];

    if (projectDefinedColumnsResponse.status === 200) {
      projectList = projectDefinedColumnsResponse.data;
      columns = projectList.map((col) => {
        return {
          id: col.id,
          group: PROJECT_FOCUS_FIELDS,
          subgroup: col.subGroup,
          subgroupOrder: 0,
          product: "",
          source: "",
          property: col.propertyName,
          metadata: null,
          title: col.name,
          defaultUnit: col.defaultUnit || "",
          dataType: col.dataType,
          tooltip: col.tooltip || "",
          canBin: col.canBin,
          withinSubgroupOrder: col.withinSubGroupOrder,
          canNormalize: col.canNormalize,
          normalizeByDefault: col.normalizeByDefault || 0,
          pythonScript: col.pythonScript,
          mongoCollection: "",
          mongoProperty: "",
          storageGroup: ""
        } as IGroupByListColumn;
      });
    }

    // Fetch project geom bins if entityKind is Well
    if (entityKind === EntityKind.Well) {
      const geomBinColumns = (await fetchGeomBins(`projectId=${selectedProjectId}`)).map(
        (bin) => {
          return {
            title: bin.name,
            id: bin.id,
            canBin: false,
            dataType: "Text",
            canNormalize: false,
            group: GeomBinPrefix,
            subgroup: bin.group,
            property: `${ProjectDefinedColumnPropertyPrefix}_${GeomBinPrefix}_${btoa(
              bin.group
            )}_${bin.id}`,
            withinSubgroupOrder: bin.withinSubGroupOrder,
            fieldType: "geom"
          } as IGroupByListColumn;
        }
      );

      columns = columns.concat(geomBinColumns);
    }

    return columns;
  } catch (error) {
    return [];
  }
};
